// External Imports
import get from 'lodash/fp/get.js';
import queryString from 'query-string';
import { createSelector } from 'reselect';

// Internal Imports
import { landingPageTypePathTypeMap } from '../config/types/landingPage.mjs';
import { languageCodePostTypeMap } from '../config/types/language.mjs';
import { archivePaths } from '../config/types/path.mjs';
import { boundGetFirstMatch } from './getFirstMatch.mjs';

// Local Functions
const getMatch = createSelector([get('router'), boundGetFirstMatch], ({ location }, match) => {
  const {
    pathType,
    params: { contentType },
  } = match ?? { params: {} };
  const isArchive =
    archivePaths.includes(pathType) || Object.keys(landingPageTypePathTypeMap).includes(pathType);
  const isLanding = Object.keys(landingPageTypePathTypeMap).includes(pathType);
  const isMultipleContentType = isArchive && !contentType;

  const query = queryString.parse(location.search || '', {
    arrayFormat: 'bracket',
  });

  return {
    ...match,
    isArchive,
    isLanding,
    isMultipleContentType,
    query,
    url: match?.url || location.pathname,
  };
});

const getLanguage = createSelector(boundGetFirstMatch, (match) => match.params.language);

const getContentType = createSelector(
  [getMatch],
  ({ params }) => languageCodePostTypeMap[params.language] || params.contentType,
);

const getArticleSlug = createSelector([getMatch], ({ params }) => params.slug);

const getPathType = createSelector([getMatch], ({ pathType }) => pathType);

const getUrl = createSelector([getMatch], ({ url }) => url);

const getQuery = createSelector([getMatch], ({ query }) => query);

// Module Exports
export { getArticleSlug, getContentType, getLanguage, getMatch, getPathType, getQuery, getUrl };
